const Index = () => import('./index.vue');

export default [
    {
        path: '/payments',
        name: 'PaymentsPage',
        component: Index
    }
]